import type React from "react";
import { Page as Component } from "~/components/specifics/vendors/settings/vendor_users/Page";

export const Page: React.FC = () => <Component />;
